import { axiosInstance } from '@/lib/axios';
import { BusinessTripConfigurationModel } from './types';

type Props = {
  companyId: string
}

export function getConfigurationBusinessTrips({ companyId }: Props) {
  return axiosInstance.get<BusinessTripConfigurationModel>(`/api/${companyId}/configuration/businessTrips`);
}
